export default {
    default: [
        {
            hoverControl: false,
            label: 'Social Media Meta',
            modules: [
                {
                    path: 'settings/meta/og:title',
                    content: {
                        template: 'Input',
                        label: 'Social Media Title',
                        info: 'If empty, page title will be used',
                    },
                },
                {
                    path: 'settings/meta/og:description',
                    content: {
                        template: 'Input',
                        inputType: 'textarea',
                        label: 'Social Media Description',
                        info: 'If empty, page description will be used',
                    },
                },
                {
                    path: 'settings/meta/og:image',
                    content: {
                        accept: 'image/*',
                        imageType: 'og:image',
                        template: 'ImagePreview',
                        label: 'Social Media Image',
                        info: 'Recommended 1200px x 630px',
                    },
                },
            ],
        },
    ],
};
